<template>
  <b-container id="main-container" fluid style>
    <b-row style="width: 100%; background-color: #e8e8ea" align-h="center">
      <b-col class cols="12">
        <nav-header></nav-header>
      </b-col>
    </b-row>

    <b-row style="width: 100%; margin-top: 60px" align-h="center">
      <b-col
        cols="12"
        style="padding-left: 0; padding-right: 0"
        class="main-jumbotron"
      >
        <b-row class="pt-3">
          <b-col
            style="
              font-size: 36px;
              border-bottom: 1px solid #e8e7e8;
              margin-right: 15px;
              padding-left: 0;
              padding-right: 0;
              padding-bottom: 15px;
              text-align: center;
            "
            class="center-align-small"
            >Product Overview</b-col
          >
        </b-row>
        <b-row class="pl-0 pr-0 reduced_pl_pr">
          <VueFaqAccordion
            :items="myItems"
            :activeColor="activeColorAccordian"
            :borderColor="borderColorAccordian"
          />
        </b-row>

        <b-row class="pt-3">
          <b-col
            style="
              font-size: 36px;
              border-bottom: 1px solid #e8e7e8;
              margin-right: 15px;
              padding-left: 0;
              padding-right: 0;
              padding-bottom: 15px;
              text-align: center;
            "
            class="center-align-small"
            >Ordering & Shipping</b-col
          >
        </b-row>
        <b-row class="pl-0 pr-0 reduced_pl_pr pb-5">
          <VueFaqAccordion
            :items="myItemsOrder"
            :activeColor="activeColorAccordian"
            :borderColor="borderColorAccordian"
          />
        </b-row>
        
        <b-row class="pt-3">
          <b-col
            style="
              font-size: 36px;
              border-bottom: 1px solid #e8e7e8;
              margin-right: 15px;
              padding-left: 0;
              padding-right: 0;
              padding-bottom: 15px;
              text-align: center;
            "
            class="center-align-small"
            >Truthbrush Tracker</b-col
          >
        </b-row>
        <b-row class="pl-0 pr-0 reduced_pl_pr">
          <VueFaqAccordion
            :items="myItemsTracker"
            :activeColor="activeColorAccordian"
            :borderColor="borderColorAccordian"
          />
        </b-row>
        <b-row class="pt-3">
          <b-col
            style="
              font-size: 36px;
              border-bottom: 1px solid #e8e7e8;
              margin-right: 15px;
              padding-left: 0;
              padding-right: 0;
              padding-bottom: 15px;
              text-align: center;
            "
            class="center-align-small"
            >Truthbrush Hub</b-col
          >
        </b-row>
        <b-row class="pl-0 pr-0 reduced_pl_pr">
          <VueFaqAccordion
            :items="myItemsHub"
            :activeColor="activeColorAccordian"
            :borderColor="borderColorAccordian"
          />
        </b-row>

        <b-row class="pt-3">
          <b-col
            style="
              font-size: 36px;
              border-bottom: 1px solid #e8e7e8;
              margin-right: 15px;
              padding-left: 0;
              padding-right: 0;
              padding-bottom: 15px;
              text-align: center;
            "
            class="center-align-small"
            >Pay-as-you-Go Plan</b-col
          >
        </b-row>
        <b-row class="pl-0 pr-0 reduced_pl_pr">
          <VueFaqAccordion
            :items="myPAYG"
            :activeColor="activeColorAccordian"
            :borderColor="borderColorAccordian"
          />
        </b-row>

        <b-row class="pt-3">
          <b-col
            style="
              font-size: 36px;
              border-bottom: 1px solid #e8e7e8;
              margin-right: 15px;
              padding-left: 0;
              padding-right: 0;
              padding-bottom: 15px;
              text-align: center;
            "
            class="center-align-small"
            >Truthbrush Mobile Apps</b-col
          >
        </b-row>
        <b-row class="pl-0 pr-0 reduced_pl_pr">
          <VueFaqAccordion
            :items="myItemsApp"
            :activeColor="activeColorAccordian"
            :borderColor="borderColorAccordian"
          />
        </b-row>

        <b-row class="pt-3">
          <b-col
            style="
              font-size: 36px;
              border-bottom: 1px solid #e8e7e8;
              margin-right: 15px;
              padding-left: 0;
              padding-right: 0;
              padding-bottom: 15px;
              text-align: center;
            "
            class="center-align-small"
            >Truthbrush Skin</b-col
          >
        </b-row>
        <b-row class="pl-0 pr-0 reduced_pl_pr">
          <VueFaqAccordion
            :items="myItemsSkin"
            :activeColor="activeColorAccordian"
            :borderColor="borderColorAccordian"
          />
        </b-row>
        <b-row class="pt-3">
          <b-col
            style="
              font-size: 36px;
              border-bottom: 1px solid #e8e7e8;
              padding-left: 0;
              padding-right: 0;
              padding-bottom: 15px;
              text-align: center;
            "
            class="center-align-small"
            >Kudos & Friends </b-col
          >
        </b-row>
        <b-row class="pl-0 pr-0 reduced_pl_pr pb-5">
          <VueFaqAccordion
            :items="myItemsFriend"
            :activeColor="activeColorAccordian"
            :borderColor="borderColorAccordian"
          />
        </b-row>
        
      </b-col>
    </b-row>

    <b-row style="width: 100%">
      <nav-footer></nav-footer>
    </b-row>
  </b-container>
</template>

<script>
import NavHeader from "./../components/NavHeader";
import NavFooter from "./../components/NavFooter";
import VueFaqAccordion from "vue-faq-accordion";
export default {
  name: "Contact",
  components: {
    NavHeader,
    NavFooter,
    VueFaqAccordion,
  },
  data() {
    return {
      selectindex: 0,
      activeColorAccordian: "#000000",
      borderColorAccordian: "#d9dadb",
      myItems: [
        {
          title: "What is a Truthbrush tracker?",
          value:
            "The Truthbrush tracker is a fitbit type device with  advanced, oral care tracking technology attaches to any manual or electric toothbrush - any brand. The tracker maps your brushing strokes and detects what you are doing well and the opportunities you have to improve.  Your brushing activity is displayed in the Truthbrush mobile application allowing easy visualization of key data like brushing frequency, brushing duration and brushing coverage.  Together with the app, the tracker allows you to configure helpful reminders, set goals and rewards and brush longer with a configurable beep timer.",
        },
        {
          title: "What is the Truthbrush hub?",
          value:
            "After every brushing event, the Truthbrush hub automatically receives brushing data from your tracker - without pushing any buttons; without needing your phone to be present.  The Truthbrush hub safely and securely connects to your home WiFi and the Truthbrush servers in the cloud.  Software on the hub uses industry leading security protocols to encrypt all data for maximum privacy protection.  The Truthbrush hub needs to be within 30 ft of your Truthbrush trackers.",
        },

        {
          title: "Does it work for electric toothbrush?",
          value:
            "Yes, Truthbrush trackers work with both manual and electric toothbrushes - any brand. During setup, it is important to indicate if your use a manual or electric toothbrush.",
        },
        {
          title: "Is there a monthly fee after purchasing the tracker and hub?",
          value: "Only Truthbrush Pay-as-you-Go users pay a recurring service fee to maintain the operation of their tracker and hub. For all other users who purchased Truthbrush in full, there is no additional fee to pay to use the Truthbrush app. The Truthbrush app and tracking service are unlocked and free to use with your full purchase.",
        },
        
        
        {
          title:
            "What is the difference between the tracker Pro and the Classic tracker?",
          value:
            "The Truthbrush tracker is a state of the art, connected oral care device that works like a fitness tracker to improve your oral health. Our best selling Truthbrush trackers work with your favorite toothbrush...manual or electric; adult or child; any brand. The Truthbrush tracker is fully automatic. There is no need to push any button. It starts when picked up and stops when placed back down. Together with our best in class Truthbrush app, you are on your way toward happier, healthier smiles. Choose the Truthbrush tracker with a 12 month battery life to get started on a year of healthier oral care habits. At the end of the 12 months, please recycle the devices or send them back to us & we will recycle them for you. The Truthbrush Pro tracker brings all of the benefits of the Truthbrush tracker, plus our most powerful engineering to date with longer range connectivity; better haptics and notifications plus a replaceable battery, the Truthbrush Pro tracker delivers years of healthier smiles - this is our best value!",
        },
        
        
        {
          title: "Does Truthbrush track for multiple users at the same time?",
          value:
            "Absolutely! Truthbrush is designed to track multiple users at same time, all from a single mobile app which can be installed on everyone's smart device to make the entire experience fun and engaging! Start the friendly competition by simply choosing the matching number of trackers and at least one hub. Additional hubs can be added to extend wireless coverage area.",
        },
        

        {
          title: "Who is Truthbrush for?",
          value:
            "Truthbrush was initially designed to help parents and dentists care for children. The CDC tells us that 46% of children age 2 – 19 in the US have tooth decay. Truthbrush can also be used by health-conscious adults that like to monitor their health data. It can be used just like their running app to display daily performance. Another key group is the elderly who need regular brushing but don’t always remember do it.",
        },
        
        {
          title: "Do dentists approve of Truthbrush?",
          value:
            "Yes, Truthbrush was built by dentists and with dentists to patients of all ages improve their at-home, preventive, oral care routine.  The Truthbrush Connected Oral Care system is unique in that it easily enables you to share your data with your dentist and hygienists right from the Truthbrush app.  Dentists and hygienists can now pair their chairside observations with their patients historical behavioral data to give better, more personalized feedback to each and every patient.",
        },
        {
          title: "Why did we build Truthbrush?",
          value:
            "The Truthbrush Connected Oral Care system was built by parents wanting to leverage technology to create a modern way of empowering and incentivizing kids to develop proper at-home, preventive, oral care behaviors.  In the past, only expensive electric toothbrushes offered you the opportunity to track your teeth brushing routine.  These products were very expensive and out of reach for most of us.  They also forced you to choose from a very small offering of models.  With Truthbrush, you can continue using your toothbrush of choice; manual or electric - any brand while easily seeing what you do well and how you can improve your at-home, oral care routine - all at an affordable price!",
        },
        {
          title:
            "How does Truthbrush compare to other connected toothbrush products?",
          value:
            "The Truthbrush Connected Oral Care system is different by design.  First, Truthbrush makes oral care tracking easy and automated; no buttons to push; no clumsy bluetooth connections to fumble around with.  Second, Truthbrush is not a toothbrush or toothpaste.  Truthbrush is like a fitness tracker that connects to your toothbrush and lets you use your toothbrush of choice.  Lastly, Truthbrush is advanced, connected oral health technology that drives significant and meaningful behavioral improvements at a price that everyone can afford",
        },

        
        
        {
          title:
            "Do I need to be at home to collect and view brush log of my kids?",
          value:
            "No, brushing log is collected by the hub. Once the hub and trackers are setup, phone can be used anywhere, home or remote, to view brushing log from the Truthbrush app.",
        },
        
        
        
        {
          title: "How does the Truthbrush help to improve oral hygiene?",
          value:
            "The Truthbrush Connected Oral Care system maps every brushing event and tells you what you are doing well and opportunities you have to improve.  Most families will buy toothbrush and toothpaste products but as we all know; they only work if you use them. With Truthbrush, brushing  patterns and habits become visible in a way that was not possible before. With Truthbrush, you can skip the argument of “did they brush” and focus on coaching and building positive habits. You can also provide access to your dentist making them a more active partner in the health of your family.",
        },
        {
          title: "Is the Truthbrush just for kids or can adults use it too?",
          value:
            "The Truthbrush product can be used by anybody that wants to track their brushing habits and to improve their preventive, oral care performance. Much like a fitness app, Truthbrush can help keep you on schedule, remind you to avoid skipped brushing events and highlight areas for improvement. Anybody that wants to maximize their healthy lifestyle can benefit from Truthbrush.",
        },
        
        
        
        
        
       
      ],
      myPAYG: [
        {
          title:
            "What's the difference between the \"Pay in full\" and the “Pay-as-you-Go” options?",
          value: "The \"Pay in full\" option allows unlimited use of your Truthbrush tracker and app with no further fee; the \"Pay-as-you-Go\" allows users to get started with just a small activation fee. Users then pay a monthly fee to maintain the service. Users may cancel at any time. \"Pay-as-you-Go\" plan users get new, free trackers every 24 months."
        },
        {
          title:
            "How can I get started using the Truthbrush “Pay-as-you-Go” plan?",
          value:
            "Getting started is easy.  Just sign up at https://www.truthbrush.com/#/select_t6, place your order for a Truthbrush Starter Bundle, make payment & set up your account and device upon arrival.  Truthbrush will send a confirmation email and activation code after you complete your purchase.",
        },
        {
          title: "How do I manage Truthbrush “Pay-as-you-Go” plan?",
          value:
            "Simply open the Truthbrush app, goto “Settings” and then “Manage Subscription”. You will log in using the same email used to make the purchase.",
        },
        {
          title:
            "How much does the Truthbrush “Pay-as-you-Go” plan cost?",
          value:
            "Each service plan comes with an up-front activation cost which depends on how many trackers in the plan. After that as low as 99¢/mo/user plus tax.",
        },
        {
          title:
            "When does my included complimentary 2 weeks start and end?",
          value:
            "The complimentary 2 weeks of Truthbrush “Pay-as-you-Go” Service begins at purchase, and continues for 14 days from that date. Once started, the complimentary 2 weeks cannot be paused or restarted.",
        },
        {
          title: "When is my billing cycle?",
          value:
            "Truthbrush “Pay-as-you-Go” plan starts on the date of purchase. You will be billed for your first payment once the free 2 weeks has ended. Your account will be auto-billed every month after that point. You can check details of your payments through the Truthbrush app.",
        },
        {
          title: "How can I cancel the Truthbrush “Pay-as-you-Go” plan?",
          value: "To cancel your Truthbrush “Pay-as-you-Go” plan, simply open the Truthbrush app, goto “Settings” and then click on “Manage Subscription”. The cancellation will take effect the day after the last day of the current subscription period. You do NOT need to send back your Truthbrush Tracker and Hub. They will be automatically disabled from our system."
        },
        {
          title: "How do I request my free, new tracker every 24 months?",
          value: "Each user in your Pay-as-you-Go plan will receive a free, new Pro Tracker every 24 months, automatically shipped to you. The new trackers will be linked with your service plan, and your old trackers will cease to work 2 weeks after the new trackers are activated"
        },

        {
          title: 'How long is my warranty for "Pay-as-you-Go" plan?',
          value:
            "Your Truthbrush trackers are covered under the extended, worry-free warranty for manufacturing defects as long as you maintain a paid plan. For details, please visit https://www.truthbrush.com/#/warranty",
        },
      ],
      myItemsOrder: [
        {
          title: "Do you ship to Australia, Canada and Internationally?",
          value:
            "Yes, we ship worldwide. At the checkout, select your destination country accordingly from the drop down list. If you use Paypal or Apple Pay, select your destination country during Paypal or Apple Pay checkout. Orders are shipped from the United States.",
        },
        {
          title: "Is there a shipping cost?",
          value:
            "We offer free ground shipping within United States for order value greater than $50. For international orders, there is a $9.9 shipping fee for most countries, except Canada, which we offer a slightly lower shipping rate. Express shipping options are available for both domestic and international orders at an extra cost. Orders are shipped from United States.",
        },
        {
          title: "How do I track my order?",
          value:
            "You will receive an email when your order ships, and the tracking information will be included in the email.",
        },
        {
          title: "How long does it take for my order to arrive?",
          value:
            "5-7 business days for domestic order and 7-15 business days for international order. With express shipping, this reduces to 3 business days and 5-7 business days respectively. Delay may occur during holiday seasons for the economy shipping option, so please order early.",
        },
        {
          title: "What is your refund policy?",
          value:
            "You can return your Truthbrush products for a refund within 30 days from the day you purchased them. Due to the nature of our products, we ask all customers to return their orders as soon as they realize they need to do so, but no later than 30 days after purchase. Please see Return and Refund in the footer section for more information and instruction.",
        },
        {
          title: "What is your warranty policy?",
          value:
            "All Truthbrush trackers and Truthbrush hubs are guaranteed against manufacturing defects; specifically problems caused by materials or workmanship for six (6) months from the date of original retail purchase when used in accordance with the user manual. Please see Factory Warranty in the footer section for details. If you are a Truthbrush Pay-as-you-Go plan user, your Trackers and Hubs are covered under the Truthbrush Extended Warranty for as long as the service is paid for. Please note that the Extended Warranty does not cover any accessories such as Truthbrush Skins, which are covered by the Truthbrush Limited Warranty above.",
        },
      ]
      ,
      myItemsTracker: [
        {
          title: "What type of battery does the Truthbrush Pro use?",
          value:
            "The Truthbrush Pro comes with a standard CR1620 coin-cell battery.  During setup, take the battery included in the packing and place it in the tracker to power up.  Replacement batteries can be found in your favorite traditional as well as online retailers.",
        },
        {
          title: "Does the tracker fit on my electric toothbrush?",
          value:
            "Yes, the tracker can fit onto toothbrush handle that is up to 1.2 inch in diameter.",
        },
        {
          title: "Do I need to start the tracker when I brush?",
          value:
            "No.  The Truthbrush tracker activates automatically.  You simply pick up your toothbrush of choice and brush as you normally do - no buttons to push; no extra steps.",
        },
        {
          title: "Can I configure the beep timer?",
          value:
            "Yes, the configurable beep timer is designed to help you set and achieve you brushing duration goals.  First, set an appropriate / achievable goal.  Meet kids where they are by setting an achievable goal like 45 seconds; maybe 1 minute.  One your brusher reaches the goal the beeper will sound notifying that the goal has been reached.  Over time, increase the goal in small increments until reaching the duration recommended by your dentist.  The American Dental Association recommends brushing twice a day for 2 minutes.  ",
        },
        
        {
          title: "How does the tracker know which area of mouth was covered?",
          value:
            "The Truthbrush tracker posses advanced oral care motion sensing technology that works like an exercise tracker mapping your brushing strokes.  Together with Truthbrush's proprietary software and artificial intelligence, the Truthbrush app helps you see what you are doing well and the opportunities you have to improve. ",
        },
        {
          title: "Is the Truthbrush tracker waterproof?",
          value:
            "The Truthbrush tracker is IPX4 water resistant and will work properly under normal brushing conditions. However, user must make sure the back cover for the Pro tracker is tightly closed, otherwise moisture and water can cause damage to the electronic components inside.",
        },
        {
          title: "How long does the battery last?",
          value:
            "The Truthbrush Classic tracker comes with a built in battery designed to last for up to 1 year based on twice daily brushing for 2 minutes. The Truthbrush Pro tracker comes with a replaceable battery designed to last up to 6 months based on twice daily brushing for 2 minutes. Testing conducted by Truthbrush in Feb 2022 using pre-production Truthbrush Classic and Pro trackers and software. Distance between tracker and hub also matters. The further a tracker is away from the hub, the faster the tracker uses up its battery. So it is strongly advised to keep the hub as close to the trackers as possible. Sometimes, things can happen that will rapidly use up existing battery capacity.  Going on a bumpy trip in a car or airplane may inadvertently activate the tracker and use battery capacity.  Moisture in the battery chamber as well as cold temperatures can also drain battery capacity prematurely.  For optimal battery performance, turn off the Truthbrush tracker (or take out the battery for the Pro tracker) before traveling and avoid adverse ambient conditions. Lastly, Truthbrush recommends that you always use high quality batteries from reputable manufacturers.",
        },
        {
          title: "Can I setup more than one tracker for a single user?",
          value:
            "Yes, you may setup multiple trackers (possibly at different locations) and link all of them to the same user. That way any brushing events captured by any of the trackers will contribute to this user.",
        },
        {
          title: "I am going on vacation can I take Truthbrush with me?",
          value:
            "You can take your Truthbrush trackers and hub with you but you will need to plug in the hub and connect it to the local wifi.",
        },
        
        
        {
          title: "How do I replace my Truthbrush tracker?",
          value:
            "Simply purchase a new Truthbrush tracker online or from your favorite store or dental clinic.  First, “unlink” your previous tracker from your user profile and link your new tracker. You will be able to maintain the data collected by the old tracker."
        },
        {
          title:
            "Is there a button to start the beep timer or brush tracking session?",
          value:
            "No, there is no start/stop button that needs to be pushed. The tracker activates automatically when you pick up your toothbrush with the Truthbrush tracker attached.  The configurable beep timer is also fully automated and starts when your brushing moments begin.  Small movements made when applying toothpaste or wetting the bristles is excluded from the brushing duration calculation.",
        },
        {
          title: "What does it mean if my device is no longer beeping?",
          value:
            "It may mean that the device battery is no longer active and it is time for battery replacement or a new Truthbrush. To inspect battery level, visit the tracker information panel within the Truthbrush app.",
        },
        {
          title: "How do I make sure my tracker, skin and brush handle are correctly aligned?",
          value:
            "A correct alignment of the Truthbrush tracker, skin and toothbrush is important for optimal performance. Truthbrush Classic tracker instructions: Ensure arrow on the back of tracker points to the dot on the skin (see diagram in user manual).  Place tracker with skin on toothbrush properly.  tracker should be right side up and facing the same direction as bristles (see diagram in user manual). Truthbrush Pro tracker instructions:  Ensure markings on skin and back of tracker are on opposing sides (see diagram in user manual).  Place tracker (with or without skin) on toothbrush properly.  Tracker should be right side up and facing the same direction as bristles (see diagram in user manual)."
        },

         {
          title: "How should I clean my Truthbrush tracker or Skin?",
          value:
            "Rinse your Truthbrush tracker and/or Skin after use to remove toothpaste and debris. Dry thoroughly. If extra care is needed, remove skin and gently wash with soap and warm water or wipe down with rubbing alcohol.",
        },
        {
          title: "My tracker is draining battery faster than I expected, what was wrong?",
          value:
            "Sometimes, things can happen that will rapidly use up existing battery capacity.  Going on a bumpy trip in a car or airplane may inadvertently activate the tracker and use battery capacity.  Moisture in the battery chamber as well as cold temperatures can also drain battery capacity prematurely.  For optimal battery performance, turn off the Truthbrush tracker before traveling and avoid adverse ambient conditions.  Make sure that the back cover for the Pro tracker is tightly closed. Lastly, Truthbrush recommends that you always use high quality batteries from reputable manufacturers."
        },

      ],
      myItemsHub: [
        {
          title: "Does the hub work with both the tracker and tracker Pro?",
          value: "Yes, the Truthbrush hub is compatible with both the Truthbrush Classic and the Truthbrush Pro trackers.",
        },
        {
          title: "Do I need more than one hub?",
          value:
            "The hub is designed to accommodate multiple Truthbrush trackers. The hub will collect data from all trackers within 30 ft. Multiple hubs can be used in large homes where the bathrooms might be spread out.",
        },
        
        {
          title:
            "I recently changed my Router and/or Wifi password, the HUB LED is showing red, how do I change/reconfig the hub password to work with my new Router/Wifi Password?",
          value:
            "If you change the password to your WiFi, we recommend that you uninstall and then install again your hub.  1. Launch the app, go to settings -> manage hub & tracker -> hub -> delete hub. 2) Unplug the hub from wall socket. 3) In the app, setup a new hub. 4) Plug the hub back into the wall and wait for the setup to complete. Happy Brushing!",
        },
        {
          title:
            "I already have a hub working at home. Can I buy another hub and add it to my system?",
          value:
            "Yes. You can add any number of hubs and they will work together seamlessly with your trackers. ",
        },
        {
          title: "Why can't I simply connect the tracker to my mobile phone?",
          value:
            "The Truthbrush Connected Oral Care system is designed differently to easily and effortlessly enable you to track your oral care behaviors with no extra steps; with no buttons to push and without the need to have a phone present.  The Truthbrush's patented design allows you to capture almost 100% of the data showing what you are doing well and the opportunities you have to improve.  Our customers have told us that they don't want to have to fight with clumsy bluetooth connections that frequently have to be reestablished.  Many of our customers don't want to have to take their phone in the bathroom with them.  And, even more of our customers do not want to give their expensive mobile phones to their children to take to the bathroom.  We personally think we should not introduce a bad habit (more screen time) while teaching a good habit.",
        },

        {
          title: "How many hub units do I need?",
          value:
            "Every household needs at least 1 Truthbrush hub.  1 hub can support many trackers.  All trackers must be within 30 ft of the Truthbrush hub.  For large homes, multiple Truthbrush hub units are recommended to keep all trackers within 30 ft of a hub.",
        },

        {
          title: "What do I do if I see hub blinks red?",
          value:
            "A blinking red LED on the Truthbrush hub means that the hub has a working connection to a Wi-Fi signal and is attempting to connect with the Truthbrush cloud servers.  The Truthbrush hub will automatically continue trying to establish the connection with the Truthbrush servers and should resolve itself in a short period of time.  If the LED continues blinking red for longer than 1 hour, unplug the hub from the power souce, wait 2 minutes and plug the hub back into the power source.  If the problem persists, open the Truthbrush setup wizard and remove the hub from your account.  After 2 minutes, use the Truthbrush setup wizard to add the hub again.",
        },

        {
          title: "What do I do when my hub is showing a constant red LED?",
          value:
            "A constant red LED on the Truthbrush hub means that the hub does not have a working connection to a Wifi signal.  This can happen when the router's password is changed, if the router does not support a 2.4GHz WiFi signal, or if the hub has been blocked by the router.  If the LED continues as a solid red for longer than 1 hour, unplug the hub from the power souce, wait 2 minutes and plug the hub back into the power source.  If the problem persists, open the Truthbrush setup wizard and remove the hub from your account.  After 2 minutes, use the Truthbrush setup wizard again to add the hub.",
        },



        
      ],
      myItemsApp: [
        {
          title: "Does my phone need to be in the bathroom when I brush?",
          value:
            "No, Truthbrush is specifically designed to avoid bringing a phone into the bathroom or the need to open an any app. Your phone can be turned off and it will not impact the ability for Truthbrush to map your brushing routine. Parents do not want their kids looking at the phone in the bathroom and the data can never be reliably collected when the phone is required.",
        },

        {
          title: "Do I need to open the app (either while brushing or after brushing) in order to sync the brushing data?",
          value:
           "No, data sync is done 100% by the hub in the background. Opening app is not required. Your phone can be turned off or can be away from home, and your data will be in sync 100% of time. When you open the app, your and your family's data will be there for you to inspect.",
        },
        {
          title: "Can I have the Truthbrush app installed on my Kids' smart device?",
          value:
            "Yes, please! We actually encourage you to do so! When the Truthbush app is on your kids phone or table, they are able to track and course correct themselves.  You will be amazed at how they will begin to take greater responsibility for their oral hygiene habits.  At the same time, you will always know how they are doing and if you need to intervene.  With Truthbrush, you can change how you interact and coach your child to improve their oral care habits.",
        },
        {
          title:
            "How do I earn badges?",
          value:
            "Badges are a great way to rewards Truthbrush users and to celebrate the daily victories!  To be eligible, you must get a brushing score of 95 or better and you must brush for at least 2 minutes.  Badges are not automatically awarded.  The best way to win them is do a great job brushing your teeth every day!",
        },
        {
          title: "Why am I not receiving notifications or alerts?",
          value:
            "To ensure that your Truthbrush Connected Oral Care system (Truthbrush tracker + Truthbrush hub) is properly configured to send push notifications to your device, please1) confirm that the Truthbrush hub is plugged in a displays a constant blue LED; 2) If notification is allowed within Truthbrush app (setting -> manage tracker user -> user -> Alerts and notifications, ensure push notification is on); 3) confirm that the Truthbrush push notification function has been enabled on your phone (Open your phone's setting icon => Go to Notifications => Scroll down to the Truthbrush app and confirm that push notifications are allowed.  If the push notifications are still not working, proceed to delete the Truthbrush app, download the app again from app store, and then sign in with your account information.",
        },
        {
          title:
            "My kids just brushed their teeth, why I am not seeing their brushing log in the app?",
          value:
            "If this is your first time brushing, there may be a delay of 1-2 minutes for the initial data processing. If you have received brushing updates previously, please1) confirm that the Truthbrush hub is plugged in a displays a constant blue LED; 2) confirm that the Truthbrsh hub is within 30 ft of your Truthbrush tracker; 3) confirm that the Truthbrush battery is operable (see tracker battery status in app under Manage hub & Tracker); 4) confirm that you are brushing for longer than 40 seconds covering at least 2 quadrants (Brushing events that do not reach or surpass these milestones are not considered a valid attempt and will not be processed. ",
        },
        {
          title:
            "Can both parents view and monitor brushing log of everyone in family?",
          value:
            "Yes, we recommend downloading the Truthbrush app on to everyone's device - Mom's, Dad's even the kid's phone or tablet.  Access to the Truthbrush app empowers and incentivizes people to take charge of their oral health - showing what they are doing well and seeing the opportunities they have to improve.  This individual and family accountability helps develop significant and meaningful improvements in people's at-home, preventive, oral care.",
        },
        {
          title:
            "Can I delete a brush event that is logged by the tracker? Can I create a brush event without the tracker?",
          value:
            "Yes, you can delete a brushing event that is inadvertently logged by the tracker. Click on the user profile after launching the Truthbrush app, select 'View All' and then 'Edit' to delete the event. Yes, you can create a manual event without the Truthbrush tracker.",
        },
        {
          title:
            "I am going to be away from home and will not bring the hub or tracker, what do I do to prevent my profile ranking from dropping?",
          value:
            "Great question! We just released a feature which allows people to mark days as 'away'. To mark days away, simply launch the Truthbrush app and click on a user profile. On the performance Chart, select 'Away' legend at bottom, and then follow the prompt on the next screen to select days you are away. Missing events on days marked away will not negatively affect your overall profile ranking score. Your dentist will be able to see the days you marked away."
        },
        {
          title:
            "Can I change the targeted brush counts and duration for the week?",
          value:
            "Yes, from the Truthbrush app, you can easily set goals for brushing frequency.  From the Users tab, select the person for whom you want to set/adjust the goal.  Tap \"Edit Goal\" from the weekly summary section and set the appropriate goal.  Truthbrush tip:  set goals that are achieveable.  Slowly increase the goal until you reach what is recommended by your dentist.  The American Dental Association recommends twice brushing daily for two minutes.",
        },
        {
          title: "Does the allowance reward automatically pay my family?",
          value:
            "No, setting an allowance allows you to calculate the amount of the total that a child should receive, it does not send them money. You will be responsible to pay them the amount that feel is appropriate. We feel that earning an allowance is a great way to motivate kids to take care of their teeth and build healthy habits.",
        },
        {
          title: "What is the difference between total time and brush time?",
          value:
            "The total time of your brush session starts when you pick up the toothbrush and ends when you put it down. The brush time excludes the time that you are placing toothpaste on the toothbrush, running it through water or cleaning. Brush time is only the time that you spend brushing teeth.",
        },
        {
          title:
            "I will be away and will not take the hub with me, how can I mark those days in the Truthbrush app so that they don’t count against my score and rewards?",
          value:
            "With Truthbrush you can mark days as “away” when you are travelling. These days will not negatively impact rewards or your ranking.",
        },
        {
          title: "Can I change the notification/alert settings?",
          value:
            'Yes, simply tap on the settings menu in the top left corner of the screen. Tap "Manage Tracker and Owner" and select the user who\'s settings you would like to change. Tap "Alerts and Notifications", you will be able to enable or disable the alerts as you like.',
        },
        {
          title:
            "What do I do if I want to share with my dentist but don't see them in the list?",
          value:
            "The Truthbrush Connected Oral Care system is designed to connect people and their dentists and hygienists.  Many oral care professionals are already in our system.  However, if your dentist isn't, go to the settings gear icon, tap \"Share Data with Dentist\" and then tap \"Add Dentist\".  Tap \"Search my Dentist\" and then \"Not Listed?\"  Fill in your dentist's name and email and we will let them know that you would like to share your information with them.",
        },
        {
          title: "I shared with my dentist, what happens next?",
          value:
            "Your dentist will accept your share request and be able to help you accompany your progress as you and your family works to improve your at-home, preventive, oral care routine. Ask you dentist to take a look at your data.  Work with your dentist to create strategies for success.",
        },
        {
          title: "How come sometimes I get red areas but I think I covered that area?",
          value:
            "The Truthbrush coverage map sometimes will show a quadrant as red (or missed) even if you brushed that area.  The Truthbrush coverage analysis actually answers 2 questions:  1) Did you brush that area? & 2) Did you spend enough time brushing that area?  This is one way that Truthbrush works to help you brush better for better at-home, preventive oral care habits.",
        },
        {
          title: "What is the code that I received from my dentist?",
          value:
            'Your dentist may have sent you a code that you can use to easily find and share with them. When you "Share with Dentist" you can enter the code and you will be automatically connected.',
        },

      ],
      myItemsSkin: [
        {
          title: "What is Truthbrush Skin?",
          value:
            "The Truthbrush skin is a fun, decorative, silicone accessory for your Truthbrush tracker.  Just like a cover for your phone, a Truthbrush skin helps protect your Truthbrush tracker.  Change your Truthbrush skin to add fun to your brushing routine.  The Truthbrush Classic tracker comes with one free skin and must have a skin to connect to your toothbrush.  The Truthbrush Pro tracker does not require a skin as it has a built in attachment mechanism.",
        },
        {
          title: "Do I need to purchase a skin for the tracker to work?",
          value:
            "The Truthbrush Classic tracker requires a Truthbrush skin to attach to your toothbrush of choice.  1 Truthbrush skin is included with each Classic tracker.  The Truthbrush Pro tracker has a built in attachment mechanism and does not require a Truthbrush skin.  Additional Truthbrush skins are fun accessories that can add fun to your brushing routine while helping keep clean your Truthbrush tracker.  Truthbrush skins work with both the Truthbrush Classic and the Truthbrush Pro trackers.",
        },
        {
          title: "How should I clean my Truthbrush Skin?",
          value:
            "Rinse your Truthbrush Skin after use to remove toothpaste and debris. Dry thoroughly. If extra care is needed, remove skin and gently wash with soap and warm water or wipe down with rubbing alcohol."
        },
      ],
      myItemsFriend: [
        {
          title: "What is Truthbrush Friends?",
          value:
            "Truthbrush Friends is a new feature in the Truthbrush app that makes oral care more fun by inviting friends to share in your daily routine. Following friends opens up a world of social interaction and creates a little healthy competition.  Make brushing fun with Truthbrush Friends. We recommend adding people you know personally as friends on Truthbrush.",
        },
        {
          title: "What Truthbrush data would be shared with a friend?",
          value: "If you accept a Truthbrush friend request, you will be sharing your user name, brush type, your brushing information (brushing streak, brushing minutes, number of followers), what type of Truthbrush tracker, Toothpaste and Toothbrush you use and the badges you have earned.  No other data is shared."
        },
        {
          title: "How do I find friends?",
          value: "The only way to find friends on Truthbrush is to ask them for their unique Truthbrush code.  Once they have shared their Truthbrush code with you, open the Truthbrush app and go to  Settings -> Manage Sharing -> Select the user at the top of the screen and input the Friend code you received. On Truthbrush, we do not allow you to search for other people."
        },
        {
          title: "Can I invite friends to follow me?",
          value: "You can invite friends to follow you, just give them your Truthbrush code.  Tap on the “Connect with Friends” button to invite your friends via text message.  If your friend already has Truthbrush, they can add you right away.  If they don’t have Truthbrush, they can take advantage of a 10% off coupon that is part of your invitation or they can simply download the app and follow you (but, in this case, they won’t be earning any badges for you to see.)"
        },
        {
          title: " I can’t find my friend",
          value: "If you've blocked someone or they've blocked you, you won't see their profile. Learn more about blocking on Truthbrush.com"
        },
        {
          title: "Can I block friends?",
          value: "In the Truthbrush app, you control your data and who you friend and share with.  Want to stop sharing with someone?  Just open the Truthbrush App, go to Settings -> Manage Sharing -> Select the user and tap “Stop Sharing” next to the person’s name."
        },
        {
          title: "Can I stop sharing?",
          value: "Yes, of course.  Open the Truthbrush App and go to Settings -> Manage Sharing -> and tap “Stop Sharing” next to the person’s name."
        },
        {
          title: "Can each user have a different list of friends to follow?",
          value: "Every Truthbrush user (even those that are under the same Truthbrush account) maintains a separate list of Friends they are following and Friends with whom they are sharing.  The Friend/Follower list for each user can be managed separately.  In the Truthbrush App, go to Setting -> Manage Sharing ->and select the user you want to manage."
        },
        {
          title: " Are users in my family automatically added to my friend list?",
          value: "Yes, all users under the same Truthbrush account are automatically added to your Friend list and you data is visible to them.  Users under the same account can not stop sharing with other users on the same account."
        },
        {
          title: "If my child shares their brushing data with another friend, will they also see my data?",
          value: "No.  Sharing is at user level.  If a user on your account shares data with a friend, only that user’s data will be visible.  If you want to share your data with that person, you will also need to share your unique Truthbrush code with that person."
        },
        {
          title: "What if I don’t want anyone to see my brushing data?",
          value: "It is easy.  Just don’t share your Truthbrush data.  Did you already share and now want to stop?  No problem.  Open the Truthbrush app, go to Settings -> Manage Sharing -> and tap “Stop Sharing” next to the person’s name."
        },
        {
          title: "How do I see my information and the data from my friends?",
          value: "Open the Truthbrush app and in the top left corner, select the user for a customized feed that only shows their information and their friend’s information.  Remember, your family members that use the same Truthbrush account will also appear.  Activities from the friends of other users on the account will not appear."
        },
        {
          title: "How do I see my child’s information and the data from their friends?",
          value: "Very easy.  Open the Truthbrush app and in the top left corner, select your child’s user icon.  You will see her information and her friend’s information.  Remember, family members that use the same Truthbrush account will also appear.  Activities from the friends of other users on the account will not appear."
        },
        
      ]
    };
  },
  methods: {
    click(index) {
      this.selectindex = index;
    },
  },
};
</script>

<style lang="scss">
.accordion {
  border: 0px solid !important;
}
.faq-wrapper {
  max-width: 100% !important;
}
@media (min-width: 1200px) {
  .main-jumbotron {
    padding-left: calc(50% - 600px + 45px) !important;
    padding-right: calc(50% - 600px + 45px) !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
}
@media (min-width: 1440px) {
  .main-jumbotron {
    padding-left: calc(50% - 720px + 45px) !important;
    padding-right: calc(50% - 720px + 45px) !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
}
@media (max-width: 768px) {
  .hide-when-small {
    display: none;
  }
  .height-faq {
    height: auto !important;
    overflow-y: hidden !important;
  }
  .center-align-small {
    text-align: center;
  }
}
@media (min-width: 769px) {
  .hide-when-big-769 {
    display: none;
  }
}
.height-faq {
  height: calc(100vh);
  overflow-y: scroll;
}

.hoverable2:hover {
  cursor: pointer;
  background-color: #c6e3f7;
}

.selectedfaq {
  background-color: #c6e3f7;

  .col {
    color: black;
  }
}
</style>